export default "__VITE_ASSET__slzCOjfL__"